import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import { getAfectacionesPresupuestales } from 'api/configuracion';

// eslint-disable-next-line react/prop-types
const AfectacionesPresupuestales = ({ permission }) => (
  <PlainCRUD
    title="Afectaciones Presupuestales"
    permission={permission}
    get={getAfectacionesPresupuestales}
    fields={[
      defaultFields.clave,
      defaultFields.descripcion,
    ]}
    readOnly
  />
);

export default AfectacionesPresupuestales;
